import { render, staticRenderFns } from "./EditComponent.vue?vue&type=template&id=a17ffb5a"
import script from "./EditComponent.vue?vue&type=script&lang=js"
export * from "./EditComponent.vue?vue&type=script&lang=js"
import style0 from "./EditComponent.vue?vue&type=style&index=0&id=a17ffb5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports